export const generatePrimaryHoverBubbleStyle = (bgColor, hoverColor) => ({
  bg: `radial-gradient(circle at right, ${hoverColor} 59%, ${bgColor} 59%)`,
  bgSize: '250% 100%',
  bgPos: 'left bottom',
  transition: 'all 0.35s ease',
  _hover: {
    bgPos: '20%',
    _disabled: {
      opacity: 0.5,
      bg: `radial-gradient(circle at right, ${hoverColor} 59%, ${bgColor} 59%)`,
      bgSize: '250% 100%',
      bgPos: 'left bottom'
    }
  },
  _focus: { boxShadow: '0 0 0 4px rgba(185, 220, 255, 1)' },
  _active: {
    backgroundPosition: '90%'
  },
  _disabled: { opacity: 0.5 }
});

export const generateSecondaryHoverBubbleStyle = (
  bgColor,
  bgHoverColor,
  fontHoverColor,
  borderHoverColor,
  disabledFontColor,
  disabledBorderColor,
  activeFontColor
) => ({
  bg: `radial-gradient(circle at right, ${bgHoverColor} 59%, ${bgColor} 59%)`,
  bgSize: '250% 100%',
  bgPos: 'left bottom',
  transition: 'all 0.35s ease',
  _hover: {
    bgPos: '20%',
    color: fontHoverColor,
    borderColor: borderHoverColor,
    _disabled: {
      bgColor: 'transparent',
      color: disabledFontColor,
      borderColor: disabledBorderColor,
      opacity: 0.5
    }
  },
  _focus: { boxShadow: '0 0 0 4px rgba(185, 220, 255, 1)' },
  _active: {
    color: activeFontColor,
    bgPos: '90%'
  },
  _disabled: { opacity: 0.5 }
});

export const generateTextStyling = (mainColor, hoverColor, activeFontColor, activeBgColor) => ({
  color: mainColor,
  bgColor: 'transparent',
  _hover: {
    color: hoverColor
  },
  _disabled: {
    color: mainColor,
    opacity: 0.5
  },
  _active: {
    bgColor: activeBgColor,
    color: activeFontColor
  }
});
